const PAYMENT_METADATA_KEY = 'uploadcam_payment_metadata';

export interface PaymentMetadata {
  priceId: string;
}

export function getPaymentMetadata(storage: Storage): Record<string, PaymentMetadata> {
  const storeRaw = storage.getItem(PAYMENT_METADATA_KEY);

  if (storeRaw) {
    return JSON.parse(storeRaw);
  } else {
    return {};
  }
}

export class SavePaymentMetadataInteractor {
  constructor(private readonly storage: Storage) {}

  public execute(paymentIntentId: string, metadata: PaymentMetadata): void {
    const data = getPaymentMetadata(this.storage);

    data[paymentIntentId] = metadata;
    this.storage.setItem(PAYMENT_METADATA_KEY, JSON.stringify(data));
  }
}
